import { QueryFunction } from "react-query";
import { ErrorResponse } from "./useBackendMutationFunction";
import { UrlQuery, useBackendUrl } from "./useBackendUrl";

export function useBackendQueryFunction<T>(
  path: string,
  params: UrlQuery = {}
) {
  const url = useBackendUrl(path, params);

  const queryFn: QueryFunction<T> = async ({ signal }) => {
    const requestUrl = url.includes("/api/videoWidget/")
      ? `${url}${url.includes("?") ? "&" : "?"}__ts=${Date.now()}`
      : url;
    const init = {
      signal,
      method: "GET",
      cache: "no-store" as RequestCache,
    };
    const response = await fetch(requestUrl, {
      ...init,
    });
    if (!response.ok) {
      const error: ErrorResponse = (await response.json()) as ErrorResponse;
      throw new Error(error.error);
    }
    return (await response.json()) as T;
  };

  return queryFn;
}
